"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconMegaphoneActive = Experimental__IconMegaphoneActive;
exports.IconMegaphoneActive = IconMegaphoneActive;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconMegaphoneActive/index.tsx)
 */
function IconMegaphoneActive(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M12.25 1.747a.75.75 0 0 0-1.175-.618l-4.438 3.05a1.25 1.25 0 0 1-.708.219H1.25c-.69 0-1.25.56-1.25 1.25v4.107a1.244 1.244 0 0 0 .185.66l.65 1.028.718 1.252c.72 1.256 1.51 1.885 2.363 2.032.831.144 1.577-.198 2.136-.523l.219-.127a.503.503 0 0 0 .183-.685l-1.37-2.387h.908c.228 0 .452.062.647.18l4.473 2.707a.75.75 0 0 0 1.138-.642V1.747Zm3.337 4.071a.75.75 0 1 0-.674-1.34l-1.45.73a.75.75 0 0 0 .674 1.34l1.45-.73ZM13.05 8.066a.75.75 0 0 1 .75-.75h1.45a.75.75 0 1 1 0 1.5H13.8a.75.75 0 0 1-.75-.75Zm.08 1.852a.75.75 0 0 1 1.007-.333l1.45.73a.75.75 0 1 1-.674 1.34l-1.45-.73a.75.75 0 0 1-.333-1.007Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M18 3a1 1 0 0 0-1.581-.814L9.94 6.814A1 1 0 0 1 9.36 7H3a2 2 0 0 0-2 2v5a1.991 1.991 0 0 0 .268 1.003l1 1.65 1.097 1.9c1.085 1.88 2.228 2.851 3.449 3.123 1.211.27 2.275-.204 3.058-.656l.302-.175a.75.75 0 0 0 .275-1.024L8.243 16h1.116a1 1 0 0 1 .581.186l6.479 4.628A1 1 0 0 0 18 20V3Zm4.894 4.553a1 1 0 0 1-.447 1.341l-2 1a1 1 0 1 1-.894-1.788l2-1a1 1 0 0 1 1.341.447ZM20 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm.447 3.105a1 1 0 0 0-.894 1.79l2 1a1 1 0 1 0 .894-1.79l-2-1Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconMegaphoneActive is deprecated and will be archived soon. Use IconMegaphoneActive instead.
 */
function Experimental__IconMegaphoneActive(props) {
  return /*#__PURE__*/_react["default"].createElement(IconMegaphoneActive, props);
}